import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { FRONTEND_ROUTES } from "../../../ConfigFiles/Routes/frontend_routes";

const OnboardingSuccessTester = () => {
    const navigate = useNavigate();

    // The available flows defined in your SUCCESS_FLOWS config
    const testFlows = [
        { label: "New Patient", type: "PURE_PATIENT", color: "info" },
        { label: "New Professional", type: "PURE_PROFESSIONAL", color: "success" },
        { label: "Medic -> Patient (Upgrade)", type: "PRO_TO_PATIENT", color: "warning" },
        { label: "Patient -> Medic (Upgrade)", type: "PATIENT_TO_PRO", color: "primary" }
    ];

    const launchTest = (flowType) => {
        navigate(FRONTEND_ROUTES.onboarding_success, { 
            state: { flow: flowType } 
        });
    };

    return (
        <Container className="py-5">
            <Card className="shadow-sm border-0">
                <Card.Header className="bg-dark text-white fw-bold">
                    🛠️ Onboarding Success Sandbox
                </Card.Header>
                <Card.Body>
                    <p className="text-muted">
                        Select a flow to trigger the success screen with the corresponding configuration.
                    </p>
                    <Row className="g-3">
                        {testFlows.map((flow) => (
                            <Col xs={12} md={6} key={flow.type}>
                                <Button 
                                    variant={`outline-${flow.color}`} 
                                    className="w-100 py-3 fw-bold"
                                    onClick={() => launchTest(flow.type)}
                                >
                                    Test {flow.label}
                                </Button>
                            </Col>
                        ))}
                    </Row>
                </Card.Body>
                <Card.Footer className="text-center small text-secondary">
                    Note: This bypasses API calls and goes straight to the UI.
                </Card.Footer>
            </Card>
        </Container>
    );
};

export default OnboardingSuccessTester;